export const TICK_OFFSET = 3;
export const COLUMN_OFFSET = 1;
export const ROW_HEIGHT_PX = 32;
export const TODAY = new Date();
